import AccountBoxSharpIcon from '@mui/icons-material/AccountBoxSharp';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ShareIcon from '@mui/icons-material/Share';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import SharePublicApprovalPopup from 'src/components/public-approval/share-approval.popup';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import AllScheduledPost from '../allScheduledPost/allScheduledPost.component';
import FailedPost from '../failed-posts/failedPost.component';
import ScheduledPost from '../scheduledPost/scheduledPost.component';
import { DemoHelper } from 'src/utils/demoUtil/demoUtil';


const PostInfoComponent = () => {
  const { t: translate } = useTranslation();
  const [currentTab, setCurrentTab] = useState('Upcoming Posts');
  const [popoverElement, setPopoverElement] = useState(false);
  const [isLinkPresent, setLinkPresent] = useState(false);
  const [isOrgEvent, setOrgEvent] = useState(CommonHelper.GetIsOrgLevelEvent());
  const [urlKey, setUrlKey] = useState('');
  const [shareUntil, setShareUntil] = useState('');
  const hasBrandAdminPermission = CommonHelper.CheckForPermissionAvailableForUser(
    CommonHelper.PermissionList.BRAND_ADMIN
  );
  const hasOrgAdminPermission = CommonHelper.CheckForPermissionAvailableForUser(CommonHelper.PermissionList.ORG_ADMIN);
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();
  const url = `${window.location.origin}/posts/${urlKey}`;
  const { showToast } = useToaster();

  useEffect(() => {
    hasBrandAdminPermission && !isOrgEvent && getShareApprovalPosts();
  }, []);

  const getShareApprovalPosts = () => {
    const getProps = {
      url: userModuleURL.getShareApprovalPosts,
      successCallback: getShareApprovalPostsSuccessCallback,
      failureCallback: getShareApprovalPostsFailureCallback,
    };
    HttpServices.Get(getProps);
  };

  const getShareApprovalPostsSuccessCallback = (data) => {
    setLinkPresent(data?.is_present);
    setUrlKey(data?.url_key);
    setShareUntil(data?.expire_date);
  };

  const getShareApprovalPostsFailureCallback = (message) => {
    message && showToast(message, 'e');
  };

  const handleOpenMenu = (event) => {
    setPopoverElement(event.currentTarget);
  };
  const handleOrgConnectedProfiles = (event) => {
    const checked = event.target.checked;
    setOrgEvent(checked);
    CommonHelper.SetIsOrgLevelEvent(checked);
  };
  const handleCloseMenu = () => {
    setPopoverElement(null);
  };
  const shareApprovalPostProps = {
    popoverElement: popoverElement,
    popoverElement,
    url: url,
    urlKey: urlKey,
    shareUntil: shareUntil,
    handleCloseMenu,
    getShareApprovalPosts,
  };

  const ACCOUNT_TABS = [
    {
      value: 'Upcoming Posts',
      icon: <AccountBoxSharpIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <ScheduledPost isOrgEvent={isOrgEvent} isShowOfferBanner={isShowOfferBanner}/>,
      label: translate('upcoming_post.upcoming_post_title'),
    },
    {
      value: 'Failed Posts',
      icon: <ManageAccountsIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <FailedPost isOrgEvent={isOrgEvent} isShowOfferBanner={isShowOfferBanner}/>,
      label: translate('upcoming_post.failed_post_title'),
    },
    {
      value: 'All Posts',
      icon: <ManageAccountsIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      component: <AllScheduledPost isOrgEvent={isOrgEvent} isShowOfferBanner={isShowOfferBanner}/>,
      label: translate('upcoming_post.all_post_title'),
    },
  ];
  return (
    <>
      <Helmet>
        <title>{translate('navbar.menu.upcoming_post')}</title>
      </Helmet>
      {hasOrgAdminPermission && !DemoHelper.IsDemoAccount() &&(
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1, // add bottom margin for spacing
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: 'text.primary', // use theme-based text color
            }}
          >
            {translate('common.enable_org_level_posts', 'Enable Org Level Posts')}
          </Typography>
          <StyledComponent.SwitchIcon size="small" checked={isOrgEvent} onChange={handleOrgConnectedProfiles} />
        </Box>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Tabs
          value={currentTab}
          scrollButtons="auto"
          variant="scrollable"
          sx={{ gap: '0.5rem', minHeight: '37px' }}
          allowScrollButtonsMobile
          onChange={(e, value) => setCurrentTab(value)}
        >
          {ACCOUNT_TABS.map((tab) => {
            return (
              <Tab
                sx={{
                  flexDirection: 'row',
                  gap: '0.25rem',
                  padding: 0,
                  minHeight: '10px',
                  mr: '0.75rem',
                  fontWeight: 600,
                }}
                disableRipple
                key={tab.value}
                label={tab.label}
                icon={tab.icon}
                value={tab.value}
              />
            );
          })}
        </Tabs>
        {!isOrgEvent && (
          <Button variant="contained" startIcon={<ShareIcon />} onClick={(e) => handleOpenMenu(e)}>
            {isLinkPresent ? translate('approval.link_already_shared') : translate('approval.share_public_link')}
          </Button>
        )}
      </Box>
      {!isOrgEvent && <SharePublicApprovalPopup {...shareApprovalPostProps} />}
      <Box sx={{ mb: 2 }} />
      {ACCOUNT_TABS.map((tab) => {
        const isMatched = tab.value === currentTab;
        return isMatched && <Box key={tab.value}>{tab.component}</Box>;
      })}
    </>
  );
};
export default PostInfoComponent;
